import React, { useState, useEffect } from 'react';
import { FullCycleDiscountCard } from './styled';
import routes from '@/presentation/components/Routes/routingMap';
import iconPiggy from '../../../../assets/icons/payments/icon-Piggy-Bank.svg';
import iconPiggyDesktop from '../../../../assets/icons/payments/icon-Piggy-Bank-Desktop.svg';
import iconArrow from '../../../../assets/icons/payments/icon-rightArrow.svg';
import DateHelpers from '@/core/helpers/DateHelper';

interface FullCicleDiscountProps {
  dataCycleDiscount: any;
  itemFullCycle: any;
  handlerRedirect: (route: string, item?: any) => void;
}

const FullCycleDiscount = ({
  dataCycleDiscount,
  itemFullCycle,
  handlerRedirect
}: FullCicleDiscountProps) => {
  const isCycleDiscountActivated = dataCycleDiscount?.discountPayment;
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);
  useEffect(() => {
    const updateIsMobile = () => setIsMobile(window.innerWidth < 640);
    updateIsMobile();
    window.addEventListener('resize', updateIsMobile);
    return () => window.removeEventListener('resize', updateIsMobile);
  }, []);
  const handlerGoTo = () => {
    if (isCycleDiscountActivated) {
      handlerRedirect('/pagos/detalle', itemFullCycle);
    } else {
      handlerRedirect(
        routes.student.procedures.categories.requests.fullCycleDiscount
      );
    }
  };

  if (!dataCycleDiscount) return null;

  return (
    <FullCycleDiscountCard
      tabIndex={0}
      isMobile={isMobile}
      onClick={() => handlerGoTo()}
    >
      <div className="dataLeft">
        <p>
          <strong>{dataCycleDiscount?.title}</strong>
        </p>
        <span className="purple">
          {dataCycleDiscount?.description}{' '}
          {DateHelpers.formatDateExtended2(Number(dataCycleDiscount?.endDate))}
          <img src={iconArrow} alt="actionArrow" className="action-arrow" />
        </span>
      </div>
      <div className="dataRight">
        <img
          src={isMobile ? iconPiggy : iconPiggyDesktop}
          alt="icoPiggyBank"
          className="piggyImg"
        />
      </div>
    </FullCycleDiscountCard>
  );
};

export { FullCycleDiscount };
